export type DocumentViewerState = {
  redactDocumentDialogIsOpen: boolean
  redactDocumentError: Error | null
  searchByAIPending: boolean
  searchByAIResults: {
    results: Record<string, NormalizedEntityForStore[]> // entities e.g. { PERSON: [...], ORG: [...] }
    summary: NormalizedSummaryForStore | null           // final summary (counts)
  }
  searchByAIError: Error | null
}

export type NormalizedEntityForStore = {
  text: string
  id: string
  type: string // PERSON, ORG, etc.
}

export type NormalizedSummaryForStore = {
  [entityType: string]: {
    [norm: string]: string[] // list of occurrence IDs, based on values
  }
}

// Chunk entity sent by streaming json
export type AiEntityChunk = {
  class: 'entity'
  type: string
  value: string
  start_pos?: number
  end_pos?: number
  start?: number
  end?: number
  entity_id: string
}

// Chunk final summary sent by streaming json
export type AiSummaryChunk = {
  class: 'entity_norm_values'
  entities: Array<{
    type: string
    norm: string
    ids?: string[]
    values?: string[]
  }>
}

// Error codes for Redaction AI
export type RedactionAiErrorCode =
  | 'SERVICE_DOWN'
  | 'ERROR_AFTER_CHUNKS'
  | 'STREAMING_NOT_SUPPORTED'
  | 'HTTP_ERROR'
  | 'UNKNOWN'

export class RedactionAiError extends Error {
  code: RedactionAiErrorCode
  status?: number

  constructor(code: RedactionAiErrorCode, message?: string, status?: number) {
    super(message || code)
    this.name = 'RedactionAiError'
    this.code = code
    this.status = status
  }
}
